import { useForm } from 'react-hook-form';
import { FormProvider, Table, TextField, Checkbox } from '../../../../../components';
import { Button, Container, Dialog, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';



const TABLE_COLUMNS = [
  {
    header: 'Antimicrobials Name',
    accessor: 'antimicrobials_name'
  },
  {
    header: 'Sequence No.',
    accessor: 'sequence_no'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const initialAntiMicrobialsDataObj = {
  data: [],
  loading: false
};

export const AntimicrobialsMaster = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [antimicrobialsDataObj, setAntiMicrobialsDataObj] = useState(initialAntiMicrobialsDataObj);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();



  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({ antimicrobials_name: Yup.string().required(' AntiMicrobials Name is required') }),
      Yup.object().shape({ sequence_no: Yup.string().required('Sequence No. is required') })
    ),
    defaultValues: { antimicrobials_name: '', sequence_no: 0 },
    mode: 'all'
  });
  const { handleSubmit, setValue, reset } = methods;

  useEffect(() => {
    if (selectedRecord) {
      setValue('antimicrobials_name', selectedRecord.antimicrobials_name);
      setValue('sequence_no', selectedRecord.sequence_no);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/lis-antimicrobials-update' : '/lis-antimicrobials-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        antimicrobials_name: formValues.antimicrobials_name,
        sequence_no: formValues.sequence_no,
        status: 'active'
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Antimicrobials master`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Antimicrobials  master`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/lis-antimicrobials-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Antimicrobials  master', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to deleted Antimicrobials master', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setAntiMicrobialsDataObj({ loading: true });
    const response = await request('/lis-antimicrobials-list', { method: 'GET' });
    if (response.success) {
      setAntiMicrobialsDataObj({ loading: false, data: response.data });
    } else {
      toast('Failed to AntiMicroBials Master', { variant: 'error' });
      setAntiMicrobialsDataObj({ loading: false });
    }
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3">
                Antimicroboials Master
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={`${lastPathSegment}Print`} variant="contained" disabled={!selectedRecord || currentAction}>
                  Print
                </CustomButtonn>
                <CustomButtonn id={"Exit"} variant="contained">Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Stack spacing={1}>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}> Antimicrobials Name </Typography>
                <TextField
                  name="antimicrobials_name"
                  sx={{ flex: 1 }}
                  inputProps={{ sx: { fontSize: '1.4rem' } }}
                  placeholder="Enter Antimicrobials"
                  fullWidth
                  disabled={!['new', 'edit'].includes(currentAction)}
                />

                <Typography sx={{ flex: 0.25, fontSize: '1.4rem', fontWeight: 700 }}>Sequence No.</Typography>
                <TextField
                  name="sequence_no"
                  sx={{ flex: 0.2 }}
                  type="number"
                  inputProps={{ sx: { fontSize: '1.4rem' } }}
                  placeholder="Enter Sequence"
                  disabled={!['new', 'edit'].includes(currentAction)}
                />
              </Stack>
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Antimicrobials Master Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 3 }}
          columns={TABLE_COLUMNS}
          data={antimicrobialsDataObj.data || []}
          loading={antimicrobialsDataObj.loading}
          onRowClick={(row) => {
            setOpenQueryDialog(false);
            setSelectedRecord(row);
          }}
        />
      </Dialog>
    </>
  );
};
